import ApiConfig from "../Config";
import apiService from "../services/apiService";

const profileService = {
  getProfile: (token, adminId) =>
    apiService.get(ApiConfig.getAdminById, {
      headers: { "x-access-token": token, "admin-id": adminId },
    }),
};
export default profileService;
